<button *ngIf="showSettings" class="btn" smTooltip="Settings" (click)="toggleSettings.emit()">
  <i class="fas fa-cog fa-lg"></i>
</button>
